import styles from "./Filters.module.css";
import { StylesProvider } from "@material-ui/styles";
import Switch from "@mui/material/Switch";
import { useContext, useState } from "react";
import { filterTrains } from "../../../helpers/functions";
import { TrainContext, ShowTrainsContext } from "../../../helpers/context.js";
import { deleteFilter } from "../../../helpers/functions";

const FilterItem = ({ el, index, activeFilters, setActiveFilters }) => {
  const [trains, setTrains] = useContext(TrainContext);
  const [showTrains, setshowTrains] = useContext(ShowTrainsContext);
  const [checked, setChecked] = useState(false);

  const switchStyles = {
            width: "96px",
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translate(49px)",
              padding: "8px",
            },
            "& .MuiSwitch-switchBase": {
              padding: "8px",
            },

            "& .MuiSwitch-thumb": {
              backgroundColor: "#c4c4c4",
              width: "28px",
              height: "28px",
            },
            "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
              backgroundColor: "#ffa800",
              width: "28px",
              height: "28px",
            },
            "& .MuiSwitch-track": {
              backgroundColor: "#ffffff",
              opacity: "1",
              height: "19px",
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#fcdc9d",
              opacity: "1",
              height: "19px",
            },
          }


  const handleSwitch = (event) => {
    setChecked((prev) => {
      if (prev === false) {
        setActiveFilters([...activeFilters, event.target.name]);
        const actualTrains = filterTrains(trains, [
          ...activeFilters,
          event.target.name,
        ]);
        setshowTrains(actualTrains);
      } else {
        const rezult = deleteFilter(activeFilters, event.target.name);
        setActiveFilters(rezult);
        const actualTrains = filterTrains(trains, rezult);
        setshowTrains(actualTrains);
      }

      return !prev;
    });
  };

  return (
    <div className={styles.filter} key={index}>
      <img src={el.img} alt="iconPhone" />
      <p className={styles.train_place}>{el.title}</p>

      <StylesProvider injectFirst>
        <Switch
          sx={switchStyles}
          color="red"
          checked={checked}
          name={el.label}
          onChange={(event) => {
            handleSwitch(event);
          }}
        />
      </StylesProvider>
    </div>
  );
};

export default FilterItem;
